import React from "react";
import Icon from "@ant-design/icons";

const MenuDrawerSvg = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 14H18.6154M2 8H18.6154M2 2H18.6154"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MenuDrawerIcon = (props) => <Icon component={MenuDrawerSvg} {...props} />;

export default MenuDrawerIcon;
